import styled, { keyframes } from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Content = styled.div`
  justify-content: space-between;
  align-items: center;
  width: 80%;
  color: #000;
  margin: 0 auto 10px;
`;

export const Itens = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: red;
  width: 100%;
`;

export const HeaderItens = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: red;
  width: 100%;
`;

export const Line = styled.div`
  display: grid;
  flex-direction: row;
  grid-template-columns: repeat(9, 1fr);
  min-height: 40px;
  border-bottom: 1px solid #A1A1A1;
  font-weight: ${props => props.header ? '700' : '500'};
  ${props => props.header && 'background-color: #E2E2E2;'}

  div {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  button{
    padding: 10px 20px;
    background-color: #C2C2C2;
    border: 1px solid #000;
    border-radius: 5px;
    cursor: pointer;
    font-weight: 600;
  }
`;

export const InvoiceConfirmations = styled.div`
  display: flex;
  flex-direction: column;

  p{
    margin-bottom: 5px;
  }

  input {
    width: 50%;
    border: 1px solid #000;
    margin-bottom: 5px;
    padding: 5px;
  }
`;

export const Nav = styled.div`
  display: flex;
  justify-content: space-between;

  nav {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  input {
    width: 250px;
  }
`;

export const ButtonOpen = styled.button`
  cursor: pointer;
  background-color: #3c3cff;
  color: #fff;
  padding: 5px 10px;
  border-radius: 5px;
  border: none;
  font-weight: 700;
`;

export const ReportButtonContainer = styled.div`
  padding: 1rem;
  float: right;
`;

export const GenerateReportButton = styled.button`
  font-size: 1rem;
  font-weight: 600;
  color: #FFF;
  background-color: #FF7417;
  padding: 0.75rem 1.5rem;
  border-radius: 0.25rem;
  border: none;
  margin: 0;

  &:hover {
    cursor: pointer;
  }
`;

export const DownloadReportButton = styled.a`
  font-size: 1rem;
  font-weight: 600;
  color: #FF7417;
  border: 1px solid #FF7417;
  padding: 0.75rem 1.5rem;
  border-radius: 0.25rem;
  display: inline-block;

  &:link {
    color: #FF7417 !important;
  }

  &:hover {
    color: #FF7417 !important;
  }
`;